var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#020041",
    d: "M14.142 7.637L12 3.857l-2.143 3.78v5.066a3.82 3.82 0 0 1 2.7-1.131c.561 0 1.101.128 1.585.355zm1.286 2.272v6.805h3.857zm-1.286 6.805h-4.071a2.786 2.786 0 0 1 4.071-3.42zm-5.571 0H4.714L8.57 9.91z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAch);
export default __webpack_public_path__ + "static/media/ach.0b9dbb69416ec72026044babb098cfca.svg";
export { ForwardRef as ReactComponent };